// Tracks the user's most recently visited tool routes so the home page can
// surface a "Recent" row. Lives in localStorage — per-device, no server roundtrip.
//
// Stored as the latest-first list of tool hrefs (e.g. "/paintbooth", "/eup-viewer").
// Capped at MAX_ENTRIES so the list never grows unbounded.

const STORAGE_KEY = "workshop_recent_tools_v1";
const MAX_ENTRIES = 8;

function safeRead(): string[] {
  try {
    if (typeof window === "undefined") return [];
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((h): h is string => typeof h === "string") : [];
  } catch {
    return [];
  }
}

function safeWrite(list: string[]): void {
  try {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ENTRIES)));
  } catch {
    // private mode etc.
  }
}

/** Push a tool href to the front of the recents list, dedup, cap to MAX_ENTRIES. */
export function pushRecentTool(href: string): void {
  if (!href || typeof href !== "string") return;
  const current = safeRead();
  const next = [href, ...current.filter((h) => h !== href)].slice(0, MAX_ENTRIES);
  safeWrite(next);
}

/** Read the recents list (latest first). Empty on SSR or never-visited. */
export function getRecentTools(): string[] {
  return safeRead();
}

/** Clear the recents list (used by sign-out flows if desired). */
export function clearRecentTools(): void {
  safeWrite([]);
}
